import * as moment from 'moment';

import { ParamMap, Params } from '@angular/router';

import { dateParamFormat } from 'src/shared/constants';
import { parseDateParam } from 'src/shared/utilities/utility-functions';

export const START_DATE_KEY = 'sd';
const TIME_STAMP_START_KEY = 'start';

export const toStartDateParams = (args: {
	startDate?: string | moment.Moment;
}): Params => ({
	[START_DATE_KEY]: args.startDate
		? moment(args.startDate, dateParamFormat).format(dateParamFormat)
		: undefined,
});

export const toStartDateListArgs = (
	paramMap: ParamMap
): { startDate?: string } =>
	paramMap.has(START_DATE_KEY)
		? {
			startDate: parseDateParam(paramMap.get(START_DATE_KEY)).format(dateParamFormat),
		}
		: undefined;

export const toStartParams = (args: {
	start?: string | moment.Moment;
}): Params => ({
	[START_DATE_KEY]: args.start
		? moment(args.start, dateParamFormat).format(dateParamFormat)
		: undefined,
});

export const toStartListArgs = (paramMap: ParamMap): { start?: string } =>
	paramMap.has(START_DATE_KEY)
		? {
			start: parseDateParam(paramMap.get(START_DATE_KEY)).format(dateParamFormat),
		}
		: undefined;

export const toTimeStampStartParams = (args: {
	timestampRangeStart?: string | moment.Moment;
}): Params => ({
	[TIME_STAMP_START_KEY]: args.timestampRangeStart
		? moment(args.timestampRangeStart, dateParamFormat).format(
			dateParamFormat
		)
		: undefined,
});

export const toTimeStampStartListArgs = (
	paramMap: ParamMap
): { timestampRangeStart?: string } =>
	paramMap.has(TIME_STAMP_START_KEY)
		? {
			timestampRangeStart: paramMap.get(TIME_STAMP_START_KEY),
		}
		: undefined;

export const toFirstInvoiceDateParams = (args: {
	firstInvoiceDate?: string | moment.Moment;
}): Params => ({
	[TIME_STAMP_START_KEY]: args.firstInvoiceDate
		? moment(args.firstInvoiceDate, dateParamFormat).format(dateParamFormat)
		: undefined,
});

export const toFirstInvoiceDateListArgs = (
	paramMap: ParamMap
): { firstInvoiceDate?: string } =>
	paramMap.has(TIME_STAMP_START_KEY)
		? {
			firstInvoiceDate: paramMap.get(TIME_STAMP_START_KEY),
		}
		: undefined;
